import styled, { css } from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  ${({ theme }) => css`
    width: 432px;
    padding: 24px;
  `}
`;
